import script from "./vheaderappointdvc.vue?vue&type=script&setup=true&lang=js"
export * from "./vheaderappointdvc.vue?vue&type=script&setup=true&lang=js"

import "./vheaderappointdvc.vue?vue&type=style&index=0&id=1e7e8a0a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7e8a0a"]])

export default __exports__